import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import "@fortawesome/fontawesome-free/css/all.min.css";
import Navigation from "./components/Navigation";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Index from "./pages/home";
import Services from "./pages/services";
import ServiceDetails from "./pages/serviceDetails";
import PortfolioDetails from "./pages/PortfolioDetails"; // ✅ import your portfolio details page
import PortfolioPage from "./pages/portfolioPage"
import Team from "./pages/Team";           // Team list page
import TeamDetail from "./pages/TeamDetails";  // Team detail page
import ContactPage from "./pages/contact"
import Booking from "./pages/Booking";
import Learn from "./pages/Learn";



function App() {
  return (
    <Router>
      <Navigation />
      <Routes>
        <Route path="/" element={<Index />} /> 
         <Route path="/services" element={<Services />} />
         <Route path="/booking" element={<Booking />} />
        <Route path="/learn" element={<Learn />} />
         <Route path="/" element={<Services/>} /> 
        <Route path="/services-details" element={<ServiceDetails />} />
            <Route path="/portfolio-details" element={<PortfolioDetails />} /> {/* ✅ added */}
        <Route path="/portfolioPage" element={<PortfolioPage />} /> {/* ✅ added */}
<Route path="/team" element={<Team />} />      {/* Team list page */}
  <Route path="/member/:id" element={<TeamDetail />} />  {/* Team member details */}
        <Route path="/contact" element={<ContactPage/>} />
      </Routes>
      
    </Router>
  );
}

export default App;


